
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    subTitle: {
      type: String,
      required: true,
    },
    join: {
      type: Boolean,
      default: false,
    },
  },
}
